export default {
    getLogged():boolean {
        return window.localStorage.getItem('isLogged') === 'true'
    },
    setLogged(isLogged: boolean):void {
        window.localStorage.setItem('isLogged', String(isLogged))
    },
}
